import React from "react";
import "./Team.css";

import judith from "../assets/Team/team1.jpg";
import blessing from "../assets/Team/team3.jpg";
import folagbade from "../assets/Team/team4.jpg";
import ferdinand from "../assets/Team/team5.jpg";
import ephraim from "../assets/Team/team6.jpg";
import sandra from "../assets/Team/team7.jpg";
import adebayo from "../assets/Team/team8.jpg";
import obinna from "../assets/Team/team9.jpg";
import cherise from "../assets/Team/team10.jpg";
import adebowale from "../assets/Team/team11.jpg";
import silas from "../assets/Team/team12.jpg";
import Footer from "./Footer";
import NavbarGroup from "./NavbarGroup";

const allTeamMembers = [
  {
    name: "Miss. Mathew Echera Judith",
    role: "Head Of Customer Service Experience(HCSE)",
    company: "Highbridge Group",
    image: judith,
  },

  {
    name: "Miss. Raji Blessing",
    role: "Video & Content Creator",
    company: "Highbridge Group",
    image: blessing,
  },
  {
    name: "Mr. Folagbade Adeyemi Abiodun",
    role: "Graphics Design(G.D)",
    company: "Highbridge Group",
    image: folagbade,
  },
  {
    name: "Mr. Ferdinand Njom",
    role: "Executive Media Officer To The MD",
    company: "Highbridge Group",
    image: ferdinand,
  },
  {
    name: "Mr. Ephraim Emmanuel I.",
    role: "IT/WEB Officer",
    company: "Highbridge Group",
    image: ephraim,
  },
  {
    name: "Miss. Iyere Sandra",
    role: "ST (Spa Therapist)",
    company: "Highbridge Group",
    image: sandra,
  },
  {
    name: "Mr. Adebayo Seyi",
    role: "Head, Account & Finance",
    company: "Highbridge Group",
    image: adebayo,
  },
  {
    name: "Mr. Obinna Julian",
    role: "Digital marketing/Videographer",
    company: "Highbridge Group",
    image: obinna,
  },
  {
    name: "Miss. Abokitia Oghenevona Cherise",
    role: "Floating/Intern Staff (F.I)",
    company: "Highbridge Group",
    image: cherise,
  },
  {
    name: "Mr. ADEBOWALE OLUWATOBI THOMAS",
    role: "Project & Operation Manager",
    company: "Highbridge Group",
    image: adebowale,
  },
  {
    name: "Mr. Silas Ogbaji",
    role: "Facility & Inspection Manager",
    company: "Highbridge Group",
    image: silas,
  },
];

const AllTeams = () => {
  return (
    <>
      <NavbarGroup />
      <div className="team-container">
        <h2 className="team-title">All Teams</h2>
        <div className="team-grid">
          {allTeamMembers.map((member, index) => (
            <div key={index} className="team-card">
              <img
                src={member.image}
                alt={member.name}
                className="team-image"
              />
              <h3 className="team-name">{member.name}</h3>
              <p className="team-role">{member.role}</p>
              <p className="team-company">{member.company}</p>
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default AllTeams;
